export default __webpack_public_path__ + "static/media/Harlot's Bow.6ca16a33.jpg";